import { BrowserRouter, Routes, Route, NavLink, Link } from "react-router-dom";

function Section_Mobile(props) {
  function toggleSectionContent(section) {
    let allSections = props.allSectionNames;
    let hideSections = allSections.filter((e) => e !== section);
    toggleSectionControl(section);
    for (var i = 0; i < allSections.length; i++) {
      hideSection(hideSections[i]);
    }
  }

  function toggleSectionControl(navSection) {
    let pages = document.getElementById(navSection + "-mobile-pages");
    let arrow = document.getElementById("arrow-" + navSection + "-mobile-2");

    if (pages.style.height !== "0px") {
      // pages.classList.remove("opened-section");
      // pages.classList.add("closed-section");
      pages.style.height= "0px";
      arrow.innerHTML = "keyboard_arrow_down";
    } else {
      // pages.style.display = "flex";
      // pages.classList.remove("closed-section");
      // pages.classList.add("opened-section");
      pages.style.height= "fit-content";
      arrow.innerHTML = "keyboard_arrow_up";
    }
  }
  function hideSection(item) {
    let pages = document.getElementById(item + "-mobile-pages");
    let arrow = document.getElementById("arrow-" + item + "-mobile-2");
    console.log(pages);
    console.log(arrow);
    // pages.style.display = "none";
    pages.style.height= "0px";
    arrow.innerHTML = "keyboard_arrow_down";

  }

  function toggleMobileMenuOpen(){
    let menu = document.getElementById('menu-mobile');
    if(menu.classList.contains('closed')){
        menu.classList.remove('closed');
        menu.classList.add('open');
    }else{
        menu.classList.remove('open');
        menu.classList.add('closed');
    }   
}

  return (
    <>
      <div
        className="sectionTitle"
        onClick={() => toggleSectionContent(props.sectionTitle)}
      >
        <h3>
          {props.sectionTitle}
        </h3>
        <span
          id={"arrow-" + props.sectionTitle + "-mobile-2"}
          className="material-symbols-outlined"
        >
          keyboard_arrow_down
        </span>
      </div>
      <ul id={props.sectionTitle + "-mobile-pages"} className="closed-section">
        {props.pages.map((p) => (
          <NavLink key={p.id} to={p.urlPath} className="NavPg" onClick={() => toggleMobileMenuOpen()} replace>
            <span className="material-symbols-outlined">{p.icon}</span>
            <span>{p.pgName}</span>
          </NavLink>
        ))}
      </ul>
    </>
  );
}

export default Section_Mobile;
